// extracted by mini-css-extract-plugin
export default {"user-info":"user-info_user-info__PWWHD","user-name":"user-info_user-name__35WQ6","user-image":"user-info_user-image__Koc+1"};